module.exports = __webpack_public_path__ + "static/img/logo.573c53e.png";


//////////////////
// WEBPACK FOOTER
// ./Public/Media/images/logo.png
// module id = DIDs
// module chunks = 14